<template>
    <div id="sender-mail-address">
        <div class="add-sender-address" @click="openModal()">
            <span class="sender-mail-address">Add Sender Address</span>
            <span class="material-icons sender-mail-address-icon">add</span>
        </div>
        <div v-if="data.length > 0">
            <a-table
                :key="'vtable-' + renderCount"
                :columns="cols()"
                :dataSource="data"
                :loading="loading"
                :locale="{
                    emptyText: $t('message.noVisitorFound'),
                }"
                :pagination="false"
                class="custom-table"
                rowKey="_id"
                size="small"
                @change="tableChange"
            >
                <div slot="isSenderVerified" slot-scope="text, record">
                    <span>
                        <span
                            v-if="!record.isSenderMail || (!!record.isSenderMail && record.isSenderVerified)"
                            class="material-icons verified-sender"
                            >verified</span
                        >
                        <div class="sender-not-verified" v-else>
                            <span class="isFalse">Not Verified</span>
                            <span class="material-icons refresh-icon" @click="isVerifiedControl(record)">refresh </span>
                        </div>
                    </span>
                </div>
                <div slot="isForward" slot-scope="text, record">
                    <span :class="!!record.isForward ? '' : 'isFalse'">
                        <span v-if="record.type === 'user' && record.isSenderMail === false">---</span>
                        <span v-else-if="!!record.isForward" class="material-icons verified-sender">verified</span>
                        <span v-else>Not Forwarded</span>
                    </span>
                </div>
                <div slot="idDefault" slot-scope="text, record">
                    <input
                        :disabled="
                            record.isSenderMail ? record.isSenderVerified === false : record.isVerified === false
                        "
                        type="radio"
                        :checked="text"
                        @click="changeDefaultMail(record)"
                    />
                </div>
                <div slot="delete" slot-scope="text, record">
                    <span class="delete-sender-mail" @click="deleteSenderMail(record)"> Sil </span>
                </div>
            </a-table>
            <div class="d-flex justify-content-end mt-3">
                <Pagination :page-change="pageChange" :page-sizes="pageSizes" :total="total" data-v-step="17" />
            </div>
        </div>
        <div class="data-box" v-else>
            <div class="last-session-info">
                <div class="material-icons" style="font-size: 20px">block</div>
                <div class="last-session-data" style="margin-top: 5px">No user data were found</div>
            </div>
        </div>
        <a-modal @cancel="isCreateModal = false" :footer="null" :visible="isCreateModal" centered>
            <a-steps :current="current" size="small" style="width: 50%">
                <a-step></a-step>
                <a-step></a-step>
            </a-steps>
            <div class="custom-modal-content" v-if="current === 0">
                <div class="custom-modal-header">Add Sender Address</div>
                <div class="custom-modal-body">
                    <div class="input-label">Please enter sender mail address</div>
                    <input
                        v-model:value="mailAddress"
                        class="sender-mail-address-input"
                        @keydown.enter="verifySenderMail"
                    />
                </div>
                <div
                    class="verify-btn"
                    :class="mailAddress.length > 0 ? 'active' : 'passive'"
                    @click="verifySenderMail()"
                >
                    Verify
                </div>
            </div>
            <div v-if="current === 1">
                <div class="custom-modal-header">Gmail Forward Mail</div>
                <gif-player :src="getGifSrc()"></gif-player>
                <div class="verify-btn active" @click="isCreateModal = false">Done</div>
            </div>
        </a-modal>
    </div>
</template>
<script>
import Vue from "vue";
import { mapState, mapGetters, mapActions, mapMutations } from "vuex";
import { log2 } from "../../../../utils/log2";
import MailIcon from "../icons/MailIcon.vue";
import MicrosoftIcon from "../icons/MicrosoftIcon.vue";
import Pagination from "../../../../components/Pagination.vue";
import { sendSocketMessage } from "../../../../utils/socketStream";
import CONFIG from "../../../../config/config";

const log = log2("Integration.vue");
export default Vue.extend({
    name: "SenderMailAddress",
    components: {
        MailIcon,
        MicrosoftIcon,
        Pagination,
    },
    data() {
        return {
            current: 0,
            currentSort: {
                columnKey: "createdAt",
                order: "ascend",
            },
            loading: false,
            cols: () => [
                {
                    dataIndex: "mail",
                    key: "mail",
                    title: "Mail Address",
                },
                {
                    dataIndex: "isForward",
                    key: "isForward",
                    title: "Yönlendirme",
                    scopedSlots: { customRender: "isForward" },
                },
                {
                    dataIndex: "isSenderVerified",
                    key: "isSenderVerified",
                    title: "Sender Verified",
                    scopedSlots: { customRender: "isSenderVerified" },
                },
                {
                    dataIndex: "idDefault",
                    key: "idDefault",
                    title: "Default",
                    scopedSlots: { customRender: "idDefault" },
                },
                {
                    dataIndex: "delete",
                    key: "delete",
                    title: "Sil",
                    scopedSlots: { customRender: "delete" },
                },
            ],
            data: [],
            renderCount: 0,
            defaultPageSize: 10,
            pageSizes: ["10", "25", "50", "100"],
            total: 0,
            currentPage: 1,
            perPage: 10,
            isCreateModal: false,
            mailAddress: "",
            selectedMailAddress: "",
        };
    },
    computed: {
        ...mapState({
            newSenderMail: (state) => state.mail.newSenderMail,
            updateSenderMail: (state) => state.mail.updateSenderMail,
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
            domainIsCreated: (state) => state.mail.domainIsCreated,
            allMailAddresses: (state) => state.mail.allMailAddresses,
            newForwardMailAddress: (state) => state.mail.newForwardMailAddress,
            emailDomain: (state) =>
                state.site.site.alias === "supsis"
                    ? CONFIG.EMAIL_DOMAIN
                    : `${state.site.site.alias}.${CONFIG.EMAIL_DOMAIN}`,
        }),
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({
            getSenderMailAddress: "mail/getSenderMailAddress",
            changeDefaultMailAddress: "mail/changeDefaultMailAddress",
            deleteSenderMailAction: "mail/deleteSenderMail",
        }),
        ...mapMutations({
            DELETE_MAIL_ADDRESS: "mail/DELETE_MAIL_ADDRESS",
            DELETE_SENDER_MAIL_ADDRESSES: "mail/DELETE_SENDER_MAIL_ADDRESSES",
        }),
        isVerifiedControl(record) {
            sendSocketMessage("email is_verified_sender_mail", {
                siteId: this.site._id,
                senderMailId: record._id,
                identity: record.mail,
            });
        },
        openModal() {
            this.isCreateModal = true;
            this.current = 0;
            this.mailAddress = "";
        },
        getGifSrc() {
            return `https://static.supsis.live/common/email/screenshot/gmail.mp4`;
        },
        deleteSenderMail(record) {
            console.log("deleteSenderMail-->", { record });
            this.$confirm({
                title: "Bu mail adresini silmek istediğinize emin misiniz?",
                content: "Bu işlem geri alınamaz.",
                okText: "Evet",
                okType: "danger",
                cancelText: "Hayır",
                onOk: () => {
                    if (!record.isSenderMail) {
                        sendSocketMessage("email delete_user_email", {
                            siteId: this.site._id,
                            mailAddressId: record._id,
                            identity: record.mail,
                        });
                        this.DELETE_MAIL_ADDRESS(record);
                        this.$router.replace("/integrations/mail");
                    } else {
                        sendSocketMessage("email delete_sender_email", {
                            siteId: this.site._id,
                            senderMailId: record._id,
                            identity: record.mail,
                        });
                        this.DELETE_MAIL_ADDRESS(record);
                        this.data = this.data.filter((x) => x._id !== record._id);
                        // idDefault değeri true olan bir mail silindiğinde ilk oluşturulan user mailin idDefault değerini true yapılır
                        if (!!record.idDefault) {
                            this.data = this.data.sort((a, b) => a.createdAt - b.createdAt);
                            const newDefaultMail = this.data.find(
                                (x) => x.mail === record.forwardTo && !!x.isSender && !!x.isVerified
                            );
                            this.data = this.data.map((x) => {
                                if (x._id === newDefaultMail._id) {
                                    x.idDefault = true;
                                }
                                return x;
                            });
                        }
                    }

                    this.$message.success("Mail address deleted successfully");
                },
            });
        },
        changeDefaultMail(record) {
            if (!!record.idDefault) return;
            this.changeDefaultMailAddress({ userId: this.user._id, mailAddressId: record._id }).then((res) => {
                this.data = this.data.map((item) => {
                    item.idDefault = item._id === record._id;
                    return item;
                });
                this.$message.success("Default mail address changed successfully");
            });
        },
        verifySenderMail() {
            console.log(
                "verifySenderMail-->",
                this.data.map((x) => x.mail)
            );
            const isCreatedBefore = this.data.filter((x) => x.mail === this.mailAddress).length !== 0;
            if (this.mailAddress.length === 0 || isCreatedBefore) {
                this.$message.error("Mail adresi zaten kayıtlı veya boş olamaz.");
            } else {
                this.current = 1;
                const data = {
                    siteId: this.site._id,
                    userId: this.user._id,
                    identity: this.mailAddress,
                    emailDomain: this.emailDomain,
                    forwardTo: this.selectedMailAddress.mail,
                };
                console.log("verifySenderMail data..", data);
                sendSocketMessage("email create_sender_user_email", data);
                this.$message.success("Mail adresinize gönderilen linke tıklayarak doğrulama yapınız.");
                this.mailAddress = "";
            }
        },
        pageChange(cur, sel) {
            console.log("pageChange-->", { cur, sel });
            this.currentPage = cur;
            this.perPage = sel;
        },
        async fetchPagedData() {
            this.loading = true;
            await this.fetch();
        },
        tableChange(pagination, filters, sorter) {
            console.log("tableChange-->", { pagination, filters, sorter });
            //this.fetchPagedData();
        },
        fetch() {
            this.loading = true;
            // storeda tutulan allmailaddresses listesinden farklı olarak doğrulanmamış sender mailleride getirir
            this.getSenderMailAddress({
                userId: this.user._id,
                selectedMailAddressId: this.selectedMailAddress._id,
                perPage: this.perPage,
                pageCount: this.currentPage,
                forwardTo: this.selectedMailAddress.mail,
            }).then((res) => {
                console.log("listSenderMailAddresses res..", { res });
                this.total = res.count;
                this.data = res.mailAddresses;
                this.loading = false;
            });
        },
    },
    async mounted() {
        console.log("mounted this.allMailAddresses..", this.allMailAddresses);
        if (this.allMailAddresses.length !== 0) {
            this.selectedMailAddress = this.allMailAddresses.filter(
                (x) => x._id === this.$route.params.id || (!!x.department && x.department._id === this.$route.params.id)
            )[0];
            await this.fetchPagedData();
        }
    },
    watch: {
        allMailAddresses(newValue, oldValue) {
            // sayfa ilk yüklendiğinde mounted da allmailaddress gelmiyor. bu yüzden burada da kontrol ediyoruz
            console.log("allMailAddresses watch..", { newValue, oldValue });
            this.selectedMailAddress = newValue.filter(
                (x) => x._id === this.$route.params.id || (!!x.department && x.department._id === this.$route.params.id)
            )[0];
            this.fetch();
        },
        newForwardMailAddress(value) {
            console.log("newForwardMailAddress watch..", value);
            this.data = this.data.map((x) => {
                if (x._id === value._id) {
                    return value;
                } else {
                    return x;
                }
            });
        },
        updateSenderMail(newValue, oldValue) {
            if (!newValue) return;
            this.data = this.data.map((item) => {
                if (item._id === newValue._id) {
                    item = newValue;
                }
                return item;
            });
        },
        newSenderMail(newValue) {
            this.data = [...this.data, newValue];
            this.total += 1;
        },
        currentPage(newValue, oldValue) {
            this.fetch();
        },
        perPage(newValue, oldValue) {
            this.fetch();
        },
    },
});
</script>

<style lang="scss">
#sender-mail-address {
    .ant-modal-body {
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
    }
}
</style>

<style scoped lang="scss">
.isFalse {
    background-color: #ffecec;
    padding: 5px 10px;
    color: #c65b5b;
    border-radius: 5px;
    align-items: center;
}

.sender-not-verified {
    display: flex;
    align-items: center;
}

.verified-sender {
    color: green;
    margin-left: 5px;
    font-weight: 800;
    font-size: 20px;
}

.refresh-icon {
    font-size: 18px;
    margin-left: 5px;
    cursor: pointer;
    font-weight: 700;
}

.delete-sender-mail {
    display: flex;
    align-items: center;
    cursor: pointer;
    color: #c65b5b;
    background-color: #ffecec;
    border-radius: 5px;
    padding: 1px 10px;
    width: max-content;
}

.sender-mail-done {
    width: min-content;
    border-radius: 10px;
    border: none;
    background-color: #f7c270;
    padding: 5px;
    width: 50px;
    font-size: 16px;
    font-weight: 600;
}

.custom-modal-header {
    justify-content: center;
    display: flex;
    font-size: 25px;
    font-weight: 800;
    margin-top: 15px;
}

.custom-modal-body {
    display: flex;
    justify-content: center;
    flex-direction: column;
    margin-top: 15px;

    .input-label {
        font-size: 15px;
    }
}

.sender-mail-address-input {
    width: 300px;
    border: 2px solid rgb(211, 219, 229);
    border-radius: 4px;
}

.verify-btn {
    margin-top: 15px;
    padding: 7px;
    border-radius: 10px;
    width: max-content;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
}

.passive {
    background-color: #d5d4d4;
}

.active {
    background-color: #f7c270;
}

#sender-mail-address {
    display: flex;
    flex-direction: column;
    background: var(--color-bg-default);
    position: relative;
    width: 70vw;
    height: 100%;
    padding: 30px;

    .add-sender-address {
        padding: 8px;
        background-color: #f7c270;
        border-radius: 10px;
        width: max-content;
        margin-bottom: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;

        .sender-mail-address {
            font-size: 16px;
            font-weight: 500;
        }

        .sender-mail-address-icon {
            margin-left: 5px;
        }
    }

    .data-box {
        border: 1px solid #dbe1e8;
        border-radius: 4px;
        -webkit-box-shadow: 0 1px 1px 0 rgb(0 0 0 / 13%);
        box-shadow: 0 1px 1px 0 rgb(0 0 0 / 13%);
        padding: 25px;
        display: grid;
        width: 100%;
        min-width: 500px;
        height: 118px;

        .last-session-info {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            .last-session-data {
                color: #bab5b5;
            }
        }
    }
}
</style>
